const e=async(e,t,n,r,i)=>{await e.post(`/webhooks/${t}/${n}/${r}/events/${i}/retry`)};export{e as retryWebhookEvent};
//# sourceMappingURL=retry-webhook-event.mjs.map